<script setup lang="ts">
import Navigation from '@/components/Navigation.vue'
import { useHead } from '@unhead/vue'
import { VueQueryDevtools } from '@tanstack/vue-query-devtools'

useHead({
  titleTemplate: '%s - Lyka account',
})
</script>

<template>
  <div class="flex min-h-dvh flex-col-reverse md:flex-col">
    <Navigation />

    <main class="flex grow flex-col">
      <router-view v-slot="{ Component }">
        <Suspense>
          <template #default>
            <component :is="Component" ref="mainContent" />
          </template>

          <!-- TODO(Jamie): Discuss with design how these states should be represented & extract these out to pages
          https://linear.app/lyka-pet-wellness/issue/R2-2116/ 
          -->
          <template #fallback>
            <div class="flex h-full w-full items-center justify-center">
              <span>Loading…</span>
            </div>
          </template>
          <template #error="err">
            <div class="text-error flex h-full w-full items-center justify-center">
              <span>Error loading page: {{ err?.error?.message || 'Unknown error' }}</span>
            </div>
          </template>
        </Suspense>
      </router-view>
      <VueQueryDevtools v-if="false" />
    </main>
  </div>
</template>
